import { LitElement, html } from 'lit-element'

import styles from './sbt-map-popup.css'


/**
 * Create a random string to work a an unique ID for the popups
 */
function makeid(length) {
  var result           = '';
  var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for ( var i = 0; i < length; i++ ) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

class SbtMapPopup extends LitElement {

  static get is() { return 'sbt-map-popup' }

  static get styles() { return styles }

  render() {
    return html`<slot></slot>`
  }

  static get properties() {
    return {

      coordinates: {
        type: Array
      },

      closeButton: {
        type: Boolean,
        attribute: 'close-button'
      },

      closeOnOutsideClick: {
        type: Boolean,
        attribute: 'close-on-outside-click'
      },
    }
  }

  set map(map) {
    if (map !== this._map) {
      this._map = map
      map ? this.initPopup() : (this.popup && this.popup.remove())
    }
  }

  get map() {
    return this._map
  }

  set marker(marker) {
    if (marker !== this._marker) {
      this._marker = marker
      marker ? this.initPopup() : (this.popup && this.popup.remove())
    }
  }

  get marker() {
    return this._marker
  }

  set coordinates(lngLatLike) {
    this.popup && this.popup.setLngLat(lngLatLike)
    this._lngLat = lngLatLike
  }

  get coordinates() {
    return this.popup ? this.popup.getLngLat() : this._lngLat
  }

  set closeButton(closeButton) {
    this.initialPopupOptions.closeButton = !!closeButton
  }

  get closeButton() {
    return this.initialPopupOptions.closeButton
  }

  set closeOnOutsideClick(closeOnOutsideClick) {
    this.initialPopupOptions.closeOnClick = !!closeOnOutsideClick
  }

  get closeOnOutsideClick() {
    return this.initialPopupOptions.closeOnClick
  }

  constructor(props) {
    super(props)
    this.initialPopupOptions = {
      closeButton: false,
      closeOnClick: false,
      anchor: 'bottom'
    }
    this._lngLat = [0, 0]
    this._map = null
    this._marker = null
    this.popup = null
    this.popupSlotName = 'popup-' + makeid(8)
    this.forwardPopupEvent = this.forwardPopupEvent.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.popup && this.popup.remove()
  }

  initPopup() {
    this.popup = new mapboxgl.Popup(this.initialPopupOptions)
    this.popup.setLngLat(this._lngLat)

    this.popup.on('open', function() {
      this._closeAllOtherPopups()
      this._centerPopup()
    }.bind(this))

    this.popup.on('open', this.forwardPopupEvent)
    this.popup.on('close', this.forwardPopupEvent)

    this.transferToPopupSlot()

    if (this.map) {
      this.popup.addTo(this.map)
    } else if (this.marker) {
      this.marker.marker.setPopup(this.popup)
    } else {
      console.error('sbt-map-popup could not be added to a map or marker')
    }
  }


  /**
   * Pass on the events so we can listen to them on the map wrapper
   */
  forwardPopupEvent(event) {
    switch (event.type) {
      case 'open':
        this.dispatchEvent(new CustomEvent(`sbt-map-popup-opened`, {detail: this.popup, bubbles: true, composed: true}))
        break;
      case 'close':
        this.dispatchEvent(new CustomEvent(`sbt-map-popup-closed`, {detail: this.popup, bubbles: true, composed: true}))
        break;
    }
  }

  /**
   * Center the popup on the map window
   */
  _centerPopup() {
    // this function needs to run inside the setTimeout to prevent a Safari error
    // where the popupHeight was calculated before the popup existed!
    setTimeout(() => {
      const popupLocation = this.popup._map.project(this.popup._lngLat)
      const popupHeight = this.popup._container.offsetHeight
      popupLocation.y -= (popupHeight / 2) + 16  // +16px to compensate for the close button
      this.popup._map.panTo(this.popup._map.unproject(popupLocation), { animate: true })
    })
  }


  /**
   * Close all other popup windows
   */
  _closeAllOtherPopups() {
    // console.log("CLOSE ALL");
  }


  /**
   * Transfer the popup to the slot element
   */
  transferToPopupSlot() {
    const slot = document.createElement('slot')
    slot.name = this.popupSlotName
    this.popup.setDOMContent(slot)
    this.marker ? this.marker.slot = this.popupSlotName : this.slot = this.popupSlotName
    window.ShadyCSS && ShadyCSS.styleElement(this)
  }
}

customElements.define(SbtMapPopup.is, SbtMapPopup)